import { AuditLogsData, Page } from "../types/audit-logs/AuditLogs";
import { AuditFilter } from "../types/filters";
import { axiosForShare, axiosWithAuth } from "../utils/customAxios";

const auditLogsService = {
  fetchAllAuditLogs: async (filter: AuditFilter,pageData:Page,searchTerm:string,shared:boolean,entityTypes?:string[],callId?:string): Promise<AuditLogsData> => {
    let requestQuery = "";
    if(filter){
      requestQuery += "?";
      const queryFilters: string[] = [];
      if(!callId){
        const startDateFilter = filter.startDate
        ? `startdate=${filter.startDate}%2000:00:00`
        : "";
      if (startDateFilter.trim() !== "") queryFilters.push(startDateFilter);
      const endDateFilter = filter.endDate ? `enddate=${filter.endDate}%2023:59:59` : "";
      if (endDateFilter.trim() !== "") queryFilters.push(endDateFilter);
      }
      const usersFilter = filter.changedBy
      ? filter.changedBy.map((id:number) => `changedBy=${encodeURIComponent(id)}`).join("&")
      : "";
    if (usersFilter.trim() !== "") queryFilters.push(usersFilter);
    if(filter.entityType&& filter.entityType?.length>0){
      for(let i=0; i< filter.entityType.length;i++){
        queryFilters.push(`entityTypes=${filter.entityType[i]}`);
      }
    }else{
      for(let i=0;entityTypes && i< entityTypes.length;i++){
        queryFilters.push(`entityTypes=${entityTypes[i]}`);
      }
    }
    if(callId){
      queryFilters.push(`entityFriendlyName=${callId}`)
    }else if(!callId && filter.entityType && filter.entityFriendlyName&& filter.entityFriendlyName.trim()!=="")queryFilters.push(`entityFriendlyName=${filter.entityFriendlyName}`)
    requestQuery += queryFilters.join("&");
    requestQuery+=`&skip=${pageData.skip}&take=${pageData.take}&sortField=${pageData.sort.sortField}&sortDirection=${pageData.sort.sortDirection}&searchTerm=${searchTerm}`
    }
    try {
      const axiosInstance = shared === true ? axiosForShare : axiosWithAuth
      const response = await axiosInstance.get(`/AuditLog${requestQuery}`);
      const auditLogs: AuditLogsData = response.data;
      return auditLogs;
    } catch (ex) {
      throw ex;
    }
  }
}
export default auditLogsService;